import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-20">
      <div className="w-full px-2 py-12">
        {/* Full width description */}
        <div className="text-center mb-8">
          <p className="text-gray-600 mb-6 text-lg md:text-xl leading-relaxed">
            Empowering the next generation of AI and Data Engineering professionals with cutting-edge education and practical skills.<br />
            Join our community of 100,000+ learners worldwide.
          </p>
        </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Social Links moved to center */}
          <div className="col-span-full flex justify-center">
            
            {/* Social Links */}
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com/company/futurexskills"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center hover:bg-blue-700 transition-colors"
              >
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a
                href="https://twitter.com/futurexskills"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors"
              >
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a
                href="https://github.com/futurexskill"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-600 transition-colors"
              >
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Platform Links */}
          <div className="col-span-full flex justify-center mt-6">
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-8">
              {/* Udemy Link */}
              <a
                href="https://www.udemy.com/user/future-x-skill/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0L1.608 6v12L12 24l10.392-6V6L12 0zm-1.041 17.057c-.513 0-.973-.126-1.378-.378a2.669 2.669 0 01-.892-.978 2.638 2.638 0 01-.324-1.316c0-.513.108-.973.324-1.378.216-.405.513-.729.892-.973.378-.243.864-.365 1.456-.365.513 0 .973.122 1.378.365.405.244.729.568.973.973.243.405.365.865.365 1.378 0 .486-.122.946-.365 1.316a2.669 2.669 0 01-.973.978c-.405.252-.865.378-1.378.378h-.078zm8.022-9.636c-.324.378-.729.662-1.215.851-.486.189-1.039.284-1.661.284-.405 0-.784-.054-1.139-.162a3.538 3.538 0 01-.973-.459 2.638 2.638 0 01-.689-.729c-.162-.284-.243-.608-.243-.973 0-.405.108-.784.324-1.139.216-.355.513-.635.892-.84.378-.203.824-.324 1.337-.365.513-.041 1.039.027 1.581.203.054-.378.081-.757.081-1.139 0-.405-.054-.797-.162-1.175a2.897 2.897 0 00-.486-1.013 2.435 2.435 0 00-.824-.716c-.324-.176-.689-.264-1.094-.264-.486 0-.919.135-1.297.405-.378.27-.676.635-.892 1.094l-1.824-.486c.27-.73.675-1.337 1.215-1.824C7.918.675 8.675.432 9.567.432c.676 0 1.270.108 1.783.324.513.216.946.513 1.297.892.351.378.621.824.81 1.337.189.513.284 1.066.284 1.661v5.405c0 .405.027.797.081 1.175h-2.841z"/>
                </svg>
                <span className="font-medium">View Udemy Courses</span>
              </a>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="grid grid-cols-2 gap-6 text-center">
            <div>
              <div className="text-2xl font-bold text-blue-400 mb-1">80K+</div>
              <div className="text-gray-400 text-sm">Udemy Students</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-green-400 mb-1">500+</div>
              <div className="text-gray-400 text-sm">Hours of Content</div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 mt-8 pt-8">
          <div className="flex flex-col items-center justify-center text-center">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-gray-600 text-sm">
              <p>&copy; {currentYear} FutureXSkills. All rights reserved.</p>
              <div className="flex space-x-4">
                <Link to="/privacy-policy" className="hover:text-blue-600 transition-colors">Privacy Policy</Link>
                <Link to="/terms-of-service" className="hover:text-blue-600 transition-colors">Terms of Service</Link>
                <a href="mailto:futurexskill@gmail.com" className="hover:text-blue-600 transition-colors">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
};

export default Footer;